import React from 'react';
import { useTranslation } from 'react-i18next';
import i18nMap from 'src/mapping/i18nMap.json';

import TableTemplate from '../../Charts/TableTemplate';
import DashboardCard from '../../Layout/DashboardCard';

function SecurityRiskTimeOfClick(props: { data: any; day: string }) {
  const { t } = useTranslation();

  const config = [
    { width: '50%', grow: 1, align: 'left', tooltip: true },
    { width: '30%', grow: 0, align: 'right' },
  ];
  const header = [
    t('dashboard.chart.column.action'),
    t('dashboard.chart.column.detections'),
  ];

  const timeOfClickProtectionMap = new Map<string, string>(
    Object.entries(i18nMap['timeOfClickProtection'].frontendMap)
  );

  const data: any = [];
  let totalClickTimes = 0;
  timeOfClickProtectionMap.forEach((value, key) => {
    if (key !== 'Total_URLs_clicked') {
      const clickTimes =
        props.data?.security_risk_scanTimeToClickProtection?.[props.day][key] ||
        0;
      data.push([t(value), clickTimes]);
      totalClickTimes += clickTimes;
    }
  });

  data.push([
    t('dashboard.timeOfClickProtection.totalURLsClicked'),
    totalClickTimes,
  ]);

  return (
    <DashboardCard title={t('dashboard.chart.title.timeOfClick')}>
      <TableTemplate config={config} header={header} data={data} />
    </DashboardCard>
  );
}

export default React.memo(SecurityRiskTimeOfClick);
